"use client";

import ContentApp from "@/app/apps/components/ContentApp";
import AllInOnePlatform from "@/app/components/AllInOnePlatform";
import React from "react";
import {
    DeviceMobile,
    Desktop,
    ShieldCheck,
    Lightning,
    CloudArrowUp,
    CloudArrowDown,
    Lock,
    Globe,
    Users,
    FileText,
    Code,
    Database,
    Cloud,
    Cpu,
    Bell,
    Camera,
    CheckCircle,
    CreditCard,
    Eye,
    Megaphone,
    ShoppingBag,
    WifiX,
    Wrench,
    ArrowClockwise,
    ArrowsLeftRight
} from "@/app/components/Icons/Phosphoricons"; // ✅ Updated import

import HeroSectionApps from "@/app/apps/components/HeroSectionApps";
import HighlightsApps from "@/app/apps/components/HighlightsApps";
import CustomApplicationsApps from "@/app/apps/components/CustomApplicationsApps";
import MobileDesktopAppsPricing from "@/app/pricing/components/MobileDesktopAppsPricing";

const features = [
    {
        name: 'Native Mobile Apps',
        icon: DeviceMobile,
        description: 'iOS and Android apps with native performance.',
    },
    {
        name: 'Offline Functionality',
        icon: WifiX,
        description: 'Full app functionality without internet connection, with automatic sync.',
    },
    {
        name: 'Push Notifications',
        icon: Bell,
        description: 'Real-time notifications across all platforms and devices.',
    },
    {
        name: 'Device Features Integration',
        icon: Camera,
        description: 'Access to camera, GPS, biometrics, and other native device features.',
    },
    {
        name: 'Cross-Device Sync',
        icon: ArrowClockwise,
        description: 'Seamless data synchronization across all user devices.',
    },
    {
        name: 'Desktop Applications',
        icon: Desktop,
        description: 'Powerful cross-platform desktop apps for Windows, macOS, and Linux',
    },
    {
        name: 'Hybrid & Web Apps',
        icon: Globe,
        description: 'Progressive Web Apps (PWAs) and hybrid solutions that run on both mobile and desktop.',
    },
    {
        name: 'App Store & Play Store Deployment',
        icon: CloudArrowUp,
        description: 'Full support for publishing, updates, and compliance with Apple App Store and Google Play Store requirements.',
    },
    {
        name: 'Offline Support & Caching',
        icon: Lightning,
        description: 'Optimized data caching and offline access for seamless user experience, even without internet connectivity.',
    },
    {
        name: 'Push Notifications & Alerts',
        icon: Bell,
        description: 'Real-time notifications and user alerts with Firebase Cloud Messaging and Apple Push Notification Service.',
    },
    {
        name: 'Multi-Device Syncing',
        icon: ArrowsLeftRight,
        description: 'Seamless data syncing across mobile, desktop, and web applications.',
    },
    {
        name: 'Battery & Performance Optimization',
        icon: Lightning,
        description: 'Optimized apps with minimal battery drain and efficient memory usage for mobile and desktop devices.',
    },
    {
        name: 'IoT & Wearable Integration',
        icon: Cpu,
        description: 'Build apps that connect with IoT devices, smartwatches, and other wearable technology.',
    },
    {
        name: 'Security & Biometric Authentication',
        icon: Lock,
        description: 'Enable fingerprint, facial recognition, and secure authentication for app security.',
    },
    {
        name: 'Real-Time Data Sync',
        icon: CloudArrowDown,
        description: 'Sync data instantly across devices using WebSockets, Firebase, and GraphQL subscriptions.',
    },
    {
        name: 'Cloud Storage & Backups',
        icon: Database,
        description: 'Automatic cloud storage, file syncing, and secure backups.',
    },
    {
        name: 'Low-Code & No-Code Solutions',
        icon: Wrench,
        description: 'Rapid development with no-code and low-code platforms for quick app deployment.',
    },
    {
        name: 'Enterprise-Grade Security',
        icon: ShieldCheck,
        description: 'End-to-end encryption, WAF protection, and security best practices.',
    },
    {
        name: 'GDPR & CCPA Ready',
        icon: FileText,
        description: 'Built-in features for data privacy compliance with GDPR and CCPA regulations.',
    },
    {
        name: 'ADA & WCAG 2.1 Compliance',
        icon: Users,
        description: 'Full accessibility compliance including ARIA labels, semantic HTML, keyboard navigation, and screen reader optimization.',
    },
    {
        name: 'Accessibility Features',
        icon: Eye,
        description: 'High contrast modes, resizable text, alt tags, focus indicators, and audio descriptions for all content.',
    },
    {
        name: 'Automated A11y Testing',
        icon: CheckCircle,
        description: 'Continuous monitoring and testing of accessibility standards with automated compliance checks.',
    },
    {
        name: 'AI-Powered Personalization',
        icon: Cloud,
        description: 'Deliver dynamic, tailored content based on real-time user behavior.',
    },
    {
        name: 'GraphQL & REST API Support',
        icon: Code,
        description: 'Efficient data fetching with GraphQL, REST APIs, and real-time updates via WebSockets.',
    },
    {
        name: 'Commerce Storefront',
        icon: ShoppingBag,
        description: 'Custom-built online stores with payment processing, order tracking, and analytics.',
    },
    {
        name: 'Marketing Automation',
        icon: Megaphone,
        description: 'Automate email campaigns, social media scheduling, and customer outreach.',
    },
    {
        name: 'Payment Integration',
        icon: CreditCard,
        description: 'Supports Stripe, PayPal, Apple Pay, and other secure payment gateways.',
    },
];

export default function Page() {
    return (
        <main>
            <HeroSectionApps />
            <HighlightsApps />
            <CustomApplicationsApps />
            <ContentApp />
            <AllInOnePlatform
                title="Custom Software Solutions"
                subtitle="Transform your business with custom software solutions that scale."
                features={features}
            />
            <MobileDesktopAppsPricing />
        </main>
    );
}
